import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoreButton } from '../../../_core/components/_ui/core-button';
import { FamilyWithSurveyDto } from '@families-link/shared';
import { buttonHeaderStyles } from '../../../_core/styles';

export type SendSurveyProps = {
	surveyTemplateName?: string;
	currentFamilyWithSurvey?: FamilyWithSurveyDto;
	handleSubmitSend: (f?: FamilyWithSurveyDto) => Promise<void>;
};

export const SendSurvey: FC<SendSurveyProps> = (props) => {
	const { surveyTemplateName, currentFamilyWithSurvey, handleSubmitSend } = props;

	const [t] = useTranslation();

	const handleSendSurvey = () => {
		handleSubmitSend(currentFamilyWithSurvey);
	};

	return (
		<Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
			<Typography variant="h2" sx={{ fontSize: '16px', fontWeight: 500, my: '24px' }}>
				{t('surveys.survey-results')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					flexGrow: 1,
					flexWrap: 'wrap',
					margin: 'auto',
					gap: 4,
				}}
			>
				<Typography variant="h3" sx={{ fontSize: '16px', fontWeight: 500 }}>
					{t('surveys.send-title')}
				</Typography>
				<Box sx={{ width: '65%', textAlign: 'center' }}>
					<Typography variant="body1" sx={{ fontSize: '14px' }}>
						{t('surveys.send-description').replace(
							':SurveyTemplateName',
							surveyTemplateName ? `'${surveyTemplateName}'` : 'choosen template'
						)}
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<CoreButton onClick={handleSendSurvey} sx={buttonHeaderStyles}>
						{t('surveys.send-button')}
					</CoreButton>
				</Box>
			</Box>
		</Box>
	);
};
